/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent, useMemo } from 'react'
import { Link } from '@reach/router'
import url from 'url'

import { TNotification, TNotificationType } from '~/types'
import { styles } from './styles'
import { X } from 'react-feather'

const notificationColors = {
  [TNotificationType.AcceptedOffer]: 'rgba(16, 172, 132, 0.85)',
  [TNotificationType.NewOffer]: 'rgba(58, 137, 196, 0.85)',
}

interface NotificationProps {
  notification: TNotification
  onSeen: () => any
  onDelete: () => any
}

export const Notification: FunctionComponent<NotificationProps> = ({
  notification,
  onSeen,
  onDelete,
}) => {
  const { pathname } = useMemo(() => url.parse(notification.Link), [notification.Link])

  return (
    <div css={[styles.container, notification.Seen && styles.seen]}>
      <div css={styles.section}>
        <Link
          to={pathname}
          css={styles.title}
          style={
            !notification.Seen ? { color: notificationColors[notification.Type] } : {}
          }
          onClick={(e) => {
            e.stopPropagation()
            onSeen()
          }}
        >
          {notification.Title}
        </Link>

        <div css={styles.icon} onClick={onDelete}>
          <X size={15} color="#777777" />
        </div>
      </div>

      <Link
        css={styles.section}
        to={pathname}
        onClick={(e) => {
          e.stopPropagation()
          onSeen()
        }}
      >
        <span css={styles.message}>{notification.Message}</span>
      </Link>
    </div>
  )
}
